import { TeamTag } from "@/types";

export const teamTags: { [key: string]: TeamTag } = {
  homepage: {
    mention: "internaltools-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C02BMEHBUQL",
  },
  dashboard: {
    mention: "internaltools-team",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  "support-ai": {
    mention: "crm-conversations-ai-team",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  restores: {
    mention: "internaltools-team",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  "eliza-billing": {
    mention: "team-eliza",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  billing: {
    mention: "internaltools-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C02BMEHBUQL",
  },
  "kollab-support": {
    mention: "clientportal-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C02BMEHBUQL",
  },
  saas: {
    mention: "saas-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=G01E2LQG70B",
  },
  marketplace: {
    mention: "internaltools-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C02BMEHBUQL",
  },
  "marketplace-apps-review": {
    mention: "crm-marketplace-team",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  "marketplace-app-management": {
    mention: "crm-marketplace-team",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  "marketplace-developers": {
    mention: "crm-marketplace-team",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  funnels: {
    mention: "team-funnel",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  "lc-domain": {
    mention: "team-funnel",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  "forms-surveys": {
    mention: "team-forms",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  "email-isv": {
    mention: "lcemail-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C02ACA6TY4A",
  },
  isv: {
    mention: "lcphone-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C02ACA6TY4A",
  },
  yext: {
    mention: "yext-team",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=GR8J6H22X",
  },
  wordpress: {
    mention: "wordpress-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C02649KANR4",
  },
  whatsapp: {
    mention: "team-whatsapp",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  "feature-feedbacks": {
    mention: "crm-contacts-team",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  labs: {
    mention: "crm-contacts-team",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  reputation: {
    mention: "reputation-management-team",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  reselling: {
    mention: "Pranoy Sarkar",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C05Q6EK38D6",
  },
  medias: {
    mention: "team-funnel",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  onboarding: {
    mention: "team-onboarding",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C01ET5XR4RL",
  },
  logs: {
    mention: "internaltools-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C02BMEHBUQL",
  },
  "support-affiliate-portal": {
    mention: "internaltools-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C02BMEHBUQL",
  },
  wallet: {
    mention: "team-blade-platform-devs",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C04HLQM10KU",
  },
  company: {
    mention: "internaltools-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C02BMEHBUQL",
  },
  "custom-offers": {
    mention: "internaltools-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C02BMEHBUQL",
  },
  launchpad: {
    mention: "team-onboarding",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C01ET5XR4RL",
  },
  legal: {
    mention: "internaltools-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C02BMEHBUQL",
  },
  "ai-employee": {
    mention: "ask-ai-team",
    channel: "https://slack.com/app_redirect?team=TBL752DM0&channel=CMNNHMQUU",
  },
  "premium-support": {
    mention: "internaltools-team",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C02BMEHBUQL",
  },
  tourguide: {
    mention: "team-onboarding",
    channel:
      "https://slack.com/app_redirect?team=TBL752DM0&channel=C01ET5XR4RL",
  },
};
